export default "__VITE_ASSET__zi8jWbkq__$_?nuxt_component=async&nuxt_component_name=IconIllustration&nuxt_component_export=default__"